import { BREAKPOINTS } from '../../model/model';
import { isDefined, isNotDefined } from '../../utils/util';

class SectionContent {
  constructor(options) {
    const _ = this;
    if (!options) return;
    _.option = $.extend({
      wrap: null,
      breakpoint: BREAKPOINTS,
      global: window,
      data : null
    }, options);
    _.global = (_.option.global) ? _.option.global : window;
  }

  init(obj) {
    const _ = this;
    // console.log( '# sectionContent.js init() _.option : ', _.option);
    if (isDefined(_.option.wrap) && _.option.wrap.length) _.setInstance();
    return _;
  }

  setInstance() {
    const _ = this;
    // console.log( '# sectionContent.js : _.option.data : ', _.option.data);
    function tmpl_item (item) {
      return `<div class="slick-item"><a href="${item.url}"><dl><dd class="thumb" style="background-image:url('${item.thumbnail}');">${item.category =='none' ? ``: `<span class="flag">${item.category}</span>`}<img src="${item.thumbnail}" class="thumb"></dd><dt><strong>${item.title}</strong></dt><dd class="desc">${item.desc}</dd></dl></a></div>`;
    }

    let slick3List = [];
    let slick6List = [];
    let tmpl = _.option.data.map( (section, i) => {
      if(section.contentsType === 'type3') slick3List.push(section.contentsId);
      if(section.contentsType === 'type6') slick6List.push(section.contentsId);
      if(! section.visible) return ``;
      else{
        return `
        <section class="section-content-${section.contentsType} ${section.visible}" data-order-id="${section.orderId}">
        <header><h2>${section.header}</h2></header>
        <article id="${section.contentsId}">
        ${section.items.map( (item, index) => {
          return tmpl_item(item);
        }).join('')}
        </article>
        </section>
        `;
      }
      }).join('');

    _.option.wrap.empty().append(tmpl);
    _.addEvent_slick3(slick3List);
    _.addEvent_slick6(slick6List);
  }

  addEvent_slick3 (lists) {
    // console.log('# sectionContent.js addEvent_slick3 : ', lists);
    if(lists.length == 0) return ;
    lists.forEach(function(it){
      $('#'+it).slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  }

  addEvent_slick6 (lists) {
    // console.log('# sectionContent.js addEvent_slick6 : ', lists.length, lists);
    if(lists.length == 0) return;

    lists.forEach(function(it){
      $('#'+it).slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      });
    });
  }

}

export default SectionContent;


// WEBPACK FOOTER //
// ./_src/js/main/content/SectionContent.js